import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { theme, statusSteps, getStatusIndex } from './theme';

function ProgressStepper({ currentStatus, statusColors }) {
  const { t } = useTranslation();
  const currentIndex = getStatusIndex(currentStatus);

  return (
    <Paper
      elevation={0}
      data-testid="public-status-stepper"
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative',
        }}
      >
        {/* Progress line background */}
        <Box
          sx={{
            position: 'absolute',
            top: '20px',
            left: '30px',
            right: '30px',
            height: '4px',
            backgroundColor: theme.colors.borderLight,
            borderRadius: '2px',
          }}
        />
        {/* Progress line filled */}
        <Box
          sx={{
            position: 'absolute',
            top: '20px',
            left: '30px',
            width: `${(currentIndex / (statusSteps.length - 1)) * (100 - 21)}%`,
            height: '4px',
            backgroundColor: statusColors.main,
            borderRadius: '2px',
            transition: 'width 0.5s ease',
          }}
        />

        {statusSteps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = index === currentIndex;
          const isActive = isCompleted || isCurrent;

          return (
            <Box
              key={step.key}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: isActive ? statusColors.main : theme.colors.surface,
                  border: `3px solid ${isActive ? statusColors.main : theme.colors.border}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: isActive ? 'white' : theme.colors.textLight,
                  fontSize: '14px',
                  fontWeight: '700',
                  transition: 'all 0.3s ease',
                }}
              >
                {isCompleted ? (
                  <CheckIcon sx={{ fontSize: 20 }} />
                ) : (
                  index + 1
                )}
              </Box>
              <Typography
                sx={{
                  fontSize: '11px',
                  fontWeight: isCurrent ? '700' : '500',
                  color: isCurrent ? statusColors.main : theme.colors.textMuted,
                  marginTop: '8px',
                  textAlign: 'center',
                  maxWidth: '70px',
                }}
              >
                {t(`public_maintenance.${step.labelKey}`)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
}

export default ProgressStepper;
